import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function BreakingTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/articles", { params: { breaking: true, limit: 10 } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <div className="bg-[color:var(--accent)] text-white" data-testid="breaking-ticker">
      <div className="container-editorial flex items-center">
        <div className="flex items-center gap-2 py-3 pr-6 border-r border-white/30 shrink-0">
          <span className="pulse-dot" />
          <span className="kicker">ITTV · Breaking</span>
        </div>
        <div className="flex-1 overflow-hidden">
          <Marquee gradient={false} speed={40} pauseOnHover>
            {items.map((it) => (
              <Link key={it.slug} to={`/article/${it.slug}`} className="marquee-item hover:underline" data-testid={`ticker-${it.slug}`}>
                <span className="kicker opacity-70">{it.category_name}</span>
                <span className="font-body text-sm">{it.title}</span>
                <span className="opacity-50">///</span>
              </Link>
            ))}
          </Marquee>
        </div>
      </div>
    </div>
  );
}
